// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m9JGc","colBig":"styles_colBig__33n5c","colSmall":"styles_colSmall__1Gt82"};